import React from "react";
import "moment/locale/ar";
import { useTranslation } from "react-i18next";
import { IOrganizations } from "../../../setup/types/Organisation";

// ─── Styles ─────────────────────────────────────────────
import styles from "./OrganistaionItem.module.scss";

// ─── Components ─────────────────────────────────────────
import TooltipWrapper from "../../common/TooltipWrapper";

interface Props {
  organisation: IOrganizations;
  onEdit: () => void;
  handleDeleteOrganisation: () => void;
}

const OrganizationListItem = ({
  organisation,
  onEdit,
  handleDeleteOrganisation,
}: Props) => {
  const { t } = useTranslation();

  const createRow = (desc: string, value: React.ReactNode) => {
    return { desc, value };
  };

  const rows = [
    createRow(
      t("logo"),
      <div className={styles.logo}>
        <img
          src={organisation.logoUrl || "/assets/images/svg/noLogo.svg"}
          alt="logo"
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = "/assets/images/svg/noLogo.svg";
          }}
          className={styles.copy_icon}
        />
      </div>
    ),
    createRow(
      t("organisation_name"),
      <div className={styles.organisation_name}>
        <TooltipWrapper id="org_name" content={organisation?.name || ""}>
          <p dir="rtl">{organisation?.name || ""}</p>
        </TooltipWrapper>
      </div>
    ),
    createRow(
      t("code"),
      <div className={styles.organisation_code}>
        <TooltipWrapper id="org_code" content={organisation?.code || ""}>
          <p dir="rtl">{organisation?.code || ""}</p>
        </TooltipWrapper>
      </div>
    ),
    createRow(
      t("website_link"),
      <a
        href={organisation?.websiteUrl || "#"}
        target="_blank"
        className={styles.organisation_website}
        rel="noreferrer">
        <TooltipWrapper id="org_url" content={organisation?.websiteUrl || ""}>
          <p dir="ltr">{organisation?.websiteUrl || ""}</p>
        </TooltipWrapper>
      </a>
    ),
    createRow(
      t("description"),
      <div className={styles.organisation_description}>
        <TooltipWrapper
          id="org_description"
          content={organisation?.description || ""}>
          <p dir="rtl">{organisation?.description || ""}</p>
        </TooltipWrapper>
      </div>
    ),
    createRow(
      t("procedures"),
      <div className={styles.organisation_actions}>
        <div className={styles.action} onClick={handleDeleteOrganisation}>
          <img src="/assets/images/svg/delete_org.svg" alt="delete" />
        </div>
        <div className={styles.action} onClick={onEdit}>
          <img src="/assets/images/svg/edit_org.svg" alt="edit" />
        </div>
        <div className={styles.view_details} onClick={onEdit}>
          <p>{t("view_details")}</p>
          <img src="/assets/images/svg/right_arrow.svg" alt="view details" />
        </div>
      </div>
    ),
  ];

  return (
    <tr className={styles.table_row}>
      {rows.map((row, index) => (
        <td className={styles.table_value} key={index}>
          {row.value}
        </td>
      ))}
    </tr>
  );
};

export default OrganizationListItem;
